/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import style from '../../../../../../assets/styles/createQuestion.module.css';
import QuillEditor from '../../../../../atoms/QuillEditor';
import arrowIcon from '../../../../../../assets/images/upArrow.svg';
import MathJaxStaticRender from '../../../../../reusableComponents/MathJsxRender';
interface DescriptiveTextProps {
  body: any[];
  questionbutton: number;
  // eslint-disable-next-line no-unused-vars
  setbodyformultiquestion: (body: any[]) => void;
}

const DescriptveText: React.FC<DescriptiveTextProps> = ({ body, questionbutton, setbodyformultiquestion }) => {
  const editorRef = useRef<any>(null);
  const [questionIdentifier, setQuestionIdentifier] = useState<string | undefined>(
    body[questionbutton]?.question_short_identifier
  );
  const [questionDirection, setQuestionDirection] = useState<string | undefined>(
    body[questionbutton]?.question_direction
  );
  const [explanation_text, setExplanation_text] = useState(body[questionbutton]?.explaination_text);
  const [compose_text, setCompose_text] = useState(body[questionbutton]?.compose_question);
  const [videoId, setVideoId] = useState<string | undefined>(body[questionbutton]?.video_id);

  const [answer_format, setAnswer_format] = useState<any>(body[questionbutton]?.answer_format ?? 'Select');

  /* ----------------Latex Preview States ---------------- */
  const [showComposePreview, setShowComposePreview] = useState(false);
  const [showQuestionDirectionPreview, setShowQuestionDirectionPreview] = useState(false);
  const [showExplanationPreview, setShowExplanationPreview] = useState(false);

  //handle the select answer format
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value === 'Select') {
      setAnswer_format(event.target.value);
    } else {
      const answerFormat = Number(event.target.value);
      setAnswer_format(answerFormat);
    }
  };
  useEffect(() => {
    if (body[questionbutton]?.answer_format >= 0) {
      setAnswer_format(body[questionbutton]?.answer_format);
    }
  }, [body]);
  const AddUpdateBody = () => {
    const updatebody = [...body];
    updatebody[questionbutton] = {
      idx: questionbutton,
      question_type_id: body[questionbutton]?.question_type_id,
      question_short_identifier: questionIdentifier,
      question_direction: questionDirection,
      compose_question: compose_text,
      answer_format: answer_format,
      video_id: videoId ?? null,
      explaination_text: explanation_text || null,
    };
    setbodyformultiquestion(updatebody);
  };

  useEffect(() => {
    AddUpdateBody();
  }, [questionIdentifier, questionDirection, compose_text, answer_format, videoId, explanation_text]);

  function convertToBase64(str: string) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  function isBase64Check(str: string): boolean {
    try {
      return btoa(atob(str)) === str;
    } catch (e) {
      return false;
    }
  }

  function b64DecodeUnicode(str: string) {
    if (!isBase64Check(str)) {
      return str; // Return the original text if it's not Base64 encoded
    }

    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  const setRef = (data: any) => {
    editorRef.current = data;
  };

  const decode = (val?: string) => (val ? b64DecodeUnicode(val) : '');

  return (
    <div className={style.tinymce_text}>
      {/* add Question Short Identifier with tnymce*/}
      <div className={style.Question_Direction}>
        <p>
          Question Short Identifier <b className={style.red_mendantory}>*</b>
        </p>
        <textarea
          placeholder="Enter Question Short Identifier"
          className={`${style.question_identifier} ${style.Shortquestion} ${style.nonResizable}`}
          value={questionIdentifier}
          onChange={(e) => setQuestionIdentifier(e.target.value)}
        />
      </div>

      {/* add Question Direction with tnymce*/}
      <div className={`${style.Question_Direction} ${style.QuestionDirection}`}>
        <div className={style.default_itemcenter_and_spacebetween}>
          <p>Enter Question Direction</p>
          <button
            type="button"
            className={style.convert_btn}
            onClick={() => setShowQuestionDirectionPreview((prev) => !prev)}
          >
            {showQuestionDirectionPreview ? 'Edit' : 'Convert'}
          </button>
        </div>
        <div style={{ height: 'auto', flexGrow: '1' }}>
          {!showQuestionDirectionPreview ? (
            <QuillEditor defaultValue={decode(questionDirection)} onChange={(text) => setQuestionDirection(text)} />
          ) : (
            <MathJaxStaticRender html={decode(questionDirection)} />
          )}
        </div>
      </div>

      {/* add compose_text with tnymce*/}
      <div className={style.compose_text}>
        <div className={style.compose_header_row}>
          <p>
            Compose Question <b className={style.red_mendantory}>*</b>
          </p>
          <button type="button" className={style.convert_btn} onClick={() => setShowComposePreview((prev) => !prev)}>
            {showComposePreview ? 'Edit' : 'Convert'}
          </button>
        </div>
        <div style={{ height: 'auto', flexGrow: '1' }}>
          {!showComposePreview ? (
            <QuillEditor
              defaultValue={decode(compose_text)}
              onChange={(text) => setCompose_text(convertToBase64(text))}
            />
          ) : (
            <MathJaxStaticRender html={decode(compose_text)} />
          )}
        </div>
      </div>

      {/* choose answer type*/}
      <div className={style.Fractionanswertype}>
        <p>
          Choose Answer Format <b className={style.red_mendantory}>*</b>
        </p>
        <div style={{ position: 'relative' }}>
          <select
            id="answer-format"
            data-testid="answer-format-select"
            value={answer_format}
            onChange={handleChange}
            className={style.answerFormatSelect}
          >
            <option value="Select" disabled hidden>
              Select
            </option>
            <option value={0}>Numerical</option>
            <option value={1}>Alphabetical</option>
            <option value={2}>Alphanumeric</option>
            <option value={3}>User Keyboard</option>
          </select>
          {/* Custom Arrow Icon */}
          <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownArrow} />
        </div>
      </div>
      <span className={style.seprator}></span>
      {/* add explanation_video*/}
      <div className={`${style.explanation_text} ${style.videoId}`}>
        <p>Video ID</p>
        <div className={style.explanation_video}>
          <input
            type="text"
            value={videoId}
            placeholder="Enter Video ID"
            onChange={(e) => setVideoId(e.target.value)}
          />
        </div>
      </div>
      {/* add explanation_text with tnymce*/}
      <div className={style.explanation_text}>
        <div className={style.default_itemcenter_and_spacebetween}>
          <p>Add Explanation Text</p>
          <button type="button" className={style.convert_btn} onClick={() => setShowExplanationPreview((p) => !p)}>
            {showExplanationPreview ? 'Edit' : 'Convert'}
          </button>
        </div>
        <div style={{ height: 'auto', flexGrow: '1' }}>
          {!showExplanationPreview ? (
            <QuillEditor
              defaultValue={decode(explanation_text)}
              onChange={(text) => setExplanation_text(convertToBase64(text))}
            />
          ) : (
            <MathJaxStaticRender html={decode(explanation_text)} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DescriptveText;
